import api from "../../api.service";
import Swal from "sweetalert2";
import store from "../";
import router from "@/router";
const state = {
    shops: [],
    filterdShopList: [],
    shopsPages: [],
    shopContactInfoType: [],
    pageSize: 8,
    categoriesList: [],
    shopTypes: [],
    shopPage: 1,
    shopForm: {
        id: 0,
        hiddenAttributes: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false
        ],
        name: "",
        description: "",
        address: "",
        categoriesIds: [],
        phoneNumber: "",
        mobileNumber: "",
        hideMobileNumber: false,
        email: "",
        latitude: "",
        longitude: "",
        otp: Math.floor(100000 + Math.random() * 900000).toString(),
        mainImage: [],
        subImages: [],
        shopContactInfos: [],
        shopType: 0,
        visitCount: 0,
        areaId: null,
        scheduleTemplateId: null,
        isCustom: false,
        subscribeStartDate: new Date().toISOString().substr(0, 10),
        subscribeEndDate: new Date(
            new Date().setMonth(new Date().getMonth() + 1)
        )
            .toISOString()
            .substr(0, 10),
        mainSubsState: null,
        notiSubsState: null,
        imgSubsState: null,
        offerSubsState: null,
        isHidden: false,
        customSchedules: [
            {
                dayofWeek: 1,
                open: "00:00",
                close: "00:00",
                shopId: 0,
                is24H: false
            }
        ],
        smsRecords: []
    },
    filterModel: {
        category: [],
        type: [],
        area: [],
        joinDate: [],
        searchValue: "",
        isHidden: false,
        sortType: null
    },
    broadcastDto: {
        shopIds: [],
        message: ""
    },
    succeededNumbers: [],
    failedNumbers: [],
    shopNumbers: []
};
const getters = {
    shops(state) {
        return state.shops;
    },
    filterdShopList(state) {
        return state.filterdShopList;
    },
    shopsPages(state) {
        return state.shopsPages;
    },
    pageSize(state) {
        return state.pageSize;
    },
    shopPage({ shopPage }) {
        return shopPage;
    },
    shopForm(state) {
        /* eslint-disable */
        if (state.shopForm.id) {
            state.shopForm.shopContactInfos.map(link => {
                link.infoType == 7 || link.infoType == 8 || link.infoType == 9
                    ? (link.link = link.link)
                    : link.infoType == 5
                        ? (link.link = link.link.replace("https://t.me/", ""))
                    : link.infoType == 4
                    ? (link.link = link.link.replace("https://wa.me/+", ""))
                    : link.infoType == 3
                    ? (link.link = link.link.replace(
                          "https://twitter.com/@",
                          ""
                      ))
                    : link.infoType == 2
                    ? (link.link = link.link.replace(
                          "https://www.instagram.com/",
                          ""
                      ))
                    : link.infoType == 1
                    ? (link.link = link.link.replace(
                          "https://www.facebook.com/",
                          ""
                      ))
                    : (link.link = link.link.replace("https://", ""));
            });
        }
        return state.shopForm;
    },
    categoriesList(state) {
        return state.categoriesList;
    },
    shopTypes(state) {
        return state.shopTypes;
    },
    filterModel(state) {
        return state.filterModel;
    },
    shopContactInfoType(state) {
        return state.shopContactInfoType;
    },
    broadcastDto(state) {
        return state.broadcastDto;
    },
    succeededNumbers(state) {
        return state.succeededNumbers;
    },
    failedNumbers(state) {
        return state.failedNumbers;
    },
    shopNumbers(state) {
        return state.shopNumbers;
    }
};
const mutations = {
    GET_SHOPS_ITEMS(state, payload) {
        state.shops = payload.shops;
        state.filterdShopList = payload.shops;
        state.shopsPages = state.filterdShopList.slice(
            (state.shopPage - 1) * state.pageSize,
            (state.shopPage - 1) * state.pageSize + state.pageSize
        );
        state.categoriesList = payload.categoriesList;
        state.shopTypes = payload.shopTypes;
        store.dispatch("setLoading", false);
    },
    CHANGE_SHOPS_PAGE(state, payload) {
        state.shopsPages = state.filterdShopList.slice(
            (payload - 1) * state.pageSize,
            (payload - 1) * state.pageSize + state.pageSize
        );
    },
    GET_SHOP_CREATE(state, payload) {
        state.shopForm = {
            id: 0,
            name: "",
            description: "",
            address: "",
            categoriesIds: [],
            phoneNumber: "",
            mobileNumber: "",
            hideMobileNumber: false,
            email: "",
            latitude: "",
            longitude: "",
            otp: Math.floor(100000 + Math.random() * 900000).toString(),
            mainImage: [],
            subImages: [],
            shopContactInfos: [],
            shopType: 0,
            areaId: null,
            scheduleTemplateId: null,
            isCustom: false,
            subscribeStartDate: new Date().toISOString().substr(0, 10),
            subscribeEndDate: new Date(
                new Date().setMonth(new Date().getMonth() + 1)
            )
                .toISOString()
                .substr(0, 10),
            mainSubsState: null,
            notiSubsState: null,
            imgSubsState: null,
            offerSubsState: null,
            isHidden: false,
            customSchedules: [],
            smsRecords: []
        };
        state.shopContactInfoType = payload.shopContactInfoTypes;
        state.categoriesList = payload.categoriesList;
        state.shopTypes = payload.shopTypes;
        store.dispatch("setLoading", false);
    },
    GET_SHOP_DETAILS(state, payload) {
        payload.shopDto.subscribeStartDate = new Date(
            payload.shopDto.subscribeStartDate
        )
            .toISOString()
            .substr(0, 10);
        payload.shopDto.subscribeEndDate = new Date(
            payload.shopDto.subscribeEndDate
        )
            .toISOString()
            .substr(0, 10);
        payload.shopDto.mainImage = [payload.shopDto.mainImage];
        state.shopForm = payload.shopDto;
        state.categoriesList = payload.categoriesList;
        state.shopTypes = payload.shopTypes;
        state.shopContactInfoType = payload.shopContactInfoTypes;
        store.dispatch("setLoading", false);
    },
    ADD_SHOP_ITEMS(state, payload) {
        state.shops.unshift(payload);
        state.shopsPages.unshift(payload);
        if (state.shopsPages.length > state.pageSize) {
            state.shopsPages.pop();
        }
        router.push("/shop");
    },
    async UPDATE_SHOP_ITEMS(state, payload) {
        let shopIndex = state.shops.findIndex(item => item.id == payload.id);
        // if (payload.mainImage == null) {
        //     payload.mainImage = state.shops[shopIndex].mainImage;
        // }
        // Object.assign(state.shopForm, payload);
        // state.shopForm.subscribeStartDate = new Date(payload.subscribeStartDate)
        //     .toISOString()
        //     .substr(0, 10);
        // state.shopForm.subscribeEndDate = new Date(payload.subscribeEndDate)
        //     .toISOString()
        //     .substr(0, 10);
        Swal.fire({
            title: "تم التعديل !",
            text: `تم تعديل المشترك ${payload.name} بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 3000,
            onClose: () => {
                // Reload the current page after the timer ends
                window.location.reload();
              }
        });
    },
    REMOVE_SHOP(state, payload) {
        const index = state.shops.findIndex(item => item.id == payload);
        state.shops.splice(index, 1);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف المشترك ${payload.name} بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 1500
        });
        store.dispatch("fetchShops");
    },
    FILTER_IT_SHOP(state) {
        var filteredItems = state.shops.filter(shop => {
            let area = shop.areaId; // number
            let categories = shop.categoriesIds; // array
            let shopType = shop.shopType; // number
            let isHidden = shop.isHidden; // bool
            let subscribeEndDate;
            // Iterate through the subscriptions array
for (const subscription of shop.subscriptions) {
    // Check if subscriptionType is equal to 0
    if (subscription.subscriptionType === 0) {
      // Assign the value of subscribeEndDate to endDate
      subscribeEndDate = subscription.subscribeEndDate;
      break; // Stop the loop once a matching subscription is found
    }
  }

             
            let isCateg = false;
            categories.forEach(cat => {
                if (state.filterModel.category.indexOf(cat) != -1) {
                    isCateg = true;
                }
            });
            if (!!state.filterModel.joinDate) {
                return (
                    (isCateg || !state.filterModel.category.length) &&
                    (!state.filterModel.type.length ||
                        state.filterModel.type.indexOf(shopType) != -1) &&
                    (!state.filterModel.area.length ||
                        state.filterModel.area.indexOf(area) != -1) &&
                    (!state.filterModel.isHidden ||
                        (state.filterModel.isHidden && isHidden)) &&
                    ((new Date(state.filterModel.joinDate[0]).getTime() <=
                        new Date(subscribeEndDate).getTime() &&
                        new Date(state.filterModel.joinDate[1]).getTime() >=
                            new Date(subscribeEndDate).getTime()) ||
                        !state.filterModel.joinDate.length) &&
                    (!state.filterModel.searchValue.trim() ||
                        shop.name
                            .toLowerCase()
                            .indexOf(
                                state.filterModel.searchValue
                                    .toLowerCase()
                                    .trim()
                            ) != -1)
                );
            } else {
                return (
                    (isCateg || !state.filterModel.category.length) &&
                    (state.filterModel.type.indexOf(shopType) != -1 ||
                        !state.filterModel.type.length) &&
                    (state.filterModel.area.indexOf(area) != -1 ||
                        !state.filterModel.area.length) &&
                    (!state.filterModel.isHidden ||
                        (state.filterModel.isHidden && isHidden)) &&
                    (!state.filterModel.searchValue.trim() ||
                        shop.name
                            .toLowerCase()
                            .indexOf(
                                state.filterModel.searchValue
                                    .toLowerCase()
                                    .trim()
                            ) != -1)
                );
            }
        });
        state.filterdShopList = filteredItems.sort((f, l) => {
            if (state.filterModel.sortType == 1) {
                const F = f.name.toUpperCase();
                const L = l.name.toUpperCase();
                if (F > L) {
                    return 1;
                } else {
                    return -1;
                }
            } else if (state.filterModel.sortType == 2) {
                const F = f.name.toUpperCase();
                const L = l.name.toUpperCase();
                if (F < L) {
                    return 1;
                } else {
                    return -1;
                }
            } else if (state.filterModel.sortType == 3) {
                if (f.visitCount > l.visitCount) {
                    return 1;
                } else {
                    return -1;
                }
            } else if (state.filterModel.sortType == 4) {
                if (f.visitCount < l.visitCount) {
                    return 1;
                } else {
                    return -1;
                }
            } else if (state.filterModel.sortType == 5) {
                if (f.rating > l.rating) {
                    return 1;
                } else {
                    return -1;
                }
            } else if (state.filterModel.sortType == 6) {
                if (f.rating < l.rating) {
                    return 1;
                } else {
                    return -1;
                }
            } else if (state.filterModel.sortType == 7) {
                const F = new Date(f.dateCreated);
                const L = new Date(l.dateCreated);
                if (F > L) {
                    return 1;
                } else {
                    return -1;
                }
            } else if (state.filterModel.sortType == 8) {
                const F = new Date(f.dateCreated);
                const L = new Date(l.dateCreated);
                if (F < L) {
                    return 1;
                } else {
                    return -1;
                }
            }
            return 0;
        });

        store.dispatch("changePage", 1);
    },
    NEW_SHOP_SOCIAL(state, payload) {
        state.shopForm.shopContactInfos.unshift({
            id: 0,
            name: state.shopContactInfoType.filter(infoType => {
                return infoType.id == payload;
            })[0].name,
            link:
                payload == 9
                    ? ""
                    : payload == 8
                    ? "021"
                    : payload == 7
                    ? "09"
                    : payload == 5
                    ? "username"
                    : payload == 4
                    ? "963"
                    : payload == 3
                    ? "profilename"
                    : payload == 2
                    ? "profilename"
                    : payload == 1
                    ? "profilename"
                    : "www.example.com",
            infoType: payload
        });
    },
    REMOVE_SHOP_SOCIAL(state, index) {
        state.shopForm.shopContactInfos.splice(index, 1);
    },
    SEND_CODE_SMS(context, payload) {
        if (payload.result) {
            store.dispatch("setLoading", false);
            Swal.fire({
                title: "تم الإرسال !",
                text: "تم إرسال الرسالة بنجاح",
                icon: "success",
                showConfirmButton: false,
                timer: 2000
            });
        } else {
            Swal.fire({
                icon: "error",
                title: "فشل الإرسال",
                text: payload.message
            });
        }
    },
    BROADCAST_MESSAGE(context, payload) {
        store.dispatch("setLoading", false);
        // if (payload.result == false) {
        //     Swal.fire({
        //         icon: 'error',
        //         title: "فشل الإرسال",
        //         text: "لم يتم إرسال الرسالة"
        //     });
        // }
        // else {
        //     state.succeededNumbers = payload.succeededNumbers;
        //     state.failedNumbers = payload.failedNumbers;
        //     Swal.fire({
        //         title: "تم الإرسال !",
        //         text: "تم إرسال الرسائل بنجاح",
        //         icon: "success",
        //         showConfirmButton: false,
        //         timer: 2000
        //     });
        // }
        state.shopNumbers = payload;
        Swal.fire({
            title: "تم  !",
            text: "تم تصدير الأرقام لملف إكسل بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 2000
        });
    },
    ERROR_MESSAGE(state, payload) {
        store.dispatch("setLoading", false);
        Swal.fire({
            title: "يوجد خطأ !",
            text: `${payload}`,
            icon: "error",
            showConfirmButton: false,
            timer: 3000
        });
    },
    Reset_Filter_Shops_Form() {
        Object.assign(state.filterModel, {
            category: [],
            type: [],
            area: [],
            joinDate: [],
            searchValue: ""
        });
    },

    APPEND_RECORD(state, payload) {
        console.log("from shop store");
        console.log(payload);
        state.shopForm.smsRecords.unshift({
            Message: payload.message,
            SendDate: new Date().toLocaleDateString("en-UK")
        });
    }
};
const actions = {
    async fetchShops(context) {
        const { data } = await api
            .query("/api/Shop/GetShops")
            .then(data => data);
        context.commit("GET_SHOPS_ITEMS", data);
    },
    async changePage(context, payload) {
        context.commit("CHANGE_SHOPS_PAGE", payload);
    },
    async fetchShopCreate(context) {
        const { data } = await api
            .query(`/api/Shop/GetShopDetails/0`)
            .then(data => data);
        context.commit("GET_SHOP_CREATE", data);
    },
    async fetchShopDetails(context, payload) {
        const { data } = await api
            .query(`/api/Shop/GetShopDetails/${payload}`)
            .then(data => data);
        context.commit("GET_SHOP_DETAILS", data);
    },
    async setShop(context, payload) {
        store.dispatch("setLoading", true);
        payload.shopContactInfos.map(link => {
            link.infoType == 7 || link.infoType == 8 || link.infoType == 9
                ? (link.link = link.link)
                : link.infoType == 5
                    ? (link.link = "https://t.me/" + link.link)
                : link.infoType == 4
                ? (link.link = "https://wa.me/+" + link.link)
                : link.infoType == 3
                ? (link.link = "https://twitter.com/@" + link.link)
                : link.infoType == 2
                ? (link.link = "https://www.instagram.com/" + link.link)
                : link.infoType == 1
                ? (link.link = "https://www.facebook.com/" + link.link)
                : (link.link = "https://" + link.link);
        });
        if (!!payload.mainImage.length) {
            payload.mainImage = payload.mainImage[0];
        } else {
            payload.mainImage = {};
        }
        await api
            .post(
                "/api/Shop/SetShop",
                {
                    Id: payload.id,
                    Name: payload.name,
                    Description: payload.description,
                    Address: payload.address,
                    PhoneNumber: payload.phoneNumber,
                    MobileNumber: payload.mobileNumber,
                    HideMobileNumber: payload.hideMobileNumber,
                    Email: payload.email,
                    Latitude: payload.latitude,
                    Longitude: payload.longitude,
                    OTP: payload.otp.toString(),
                    ShopType: payload.shopType,
                    SubscribeStartDate: new Date(payload.subscribeStartDate),
                    SubscribeEndDate: new Date(payload.subscribeEndDate),
                    AreaId: payload.areaId,
                    CategoriesIds: payload.categoriesIds,
                    ScheduleTemplateId: payload.scheduleTemplateId,
                    IsHidden: payload.isHidden,
                    VisitCount: payload.visitCount,
                    MainImage: payload.mainImage,
                    SubImages: payload.subImages,
                    hiddenAttributes: payload.hiddenAttributes,
                    ShopContactInfos:
                        payload.shopContactInfos == null
                            ? []
                            : payload.shopContactInfos,
                    IsCustom: payload.isCustom,
                    CustomSchedules:
                        payload.customSchedules == null
                            ? []
                            : payload.customSchedules,
                    MainSubsState: +payload.mainSubsState,
                    NotiSubsState: +payload.notiSubsState,
                    ImgSubsState: +payload.imgSubsState,
                    OfferSubsState: +payload.offerSubsState,
                    SMSRecords: payload.smsRecords
                },
                {
                    timeout: null
                }
            )
            .then(response => {
                if (typeof response.data === "string") {
                    context.commit("ERROR_MESSAGE", response.data);
                } else if (payload.id == 0) {
                    context.commit("ADD_SHOP_ITEMS", response.data);
                } else {
                    context.commit("UPDATE_SHOP_ITEMS", response.data);
                    store.dispatch("setLoading", false);
                }
            });
    },
    async removeShop(context, payload) {
        await api
            .delete(`/api/Shop/RemoveShop?shopId=${payload.id}`)
            .then(data => data);
        context.commit("REMOVE_SHOP", payload);
    },
    unShiftSocial(context, payload) {
        context.commit("NEW_SHOP_SOCIAL", payload);
    },
    removeInfoSocial(context, index) {
        context.commit("REMOVE_SHOP_SOCIAL", index);
    },
    filterItShop(context) {
        context.commit("FILTER_IT_SHOP");
    },
    async sendCodeSMS(context, id) {
        const { data } = await api
            .query(`/api/Shop/SendCodeSMS?id=${id}`)
            .then(data => data);
        context.commit("SEND_CODE_SMS", data);
    },
    async broadcastMessage(context, payload) {
        store.dispatch("setLoading", true);
        const { data } = await api
            .post("/api/Shop/BroadcastSMSMessage", payload, {
                timeout: 3600000
            })
            .then(data => data);
        context.commit("BROADCAST_MESSAGE", data);
    },
    resetFilterShopsForm({ commit }) {
        commit("Reset_Filter_Shops_Form");
    },
    setShopPage({ state }, payload) {
        state.shopPage = payload;
        return state.shopPage;
    }
};

const shop = { state, getters, mutations, actions };

export default shop;
